import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import IconBack from "../assets/images/backArrow.webp";
import IconBag from "../assets/images/ShoppingBag.webp";
import "./Kredit.css";
import { useSelector } from "react-redux";
import axios from "axios";
import CONFIG from "../config/config";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import NumberFormat from "react-number-format";
import error404 from "../assets/images/404.webp";
import Loading from "../components/Loading";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Header from "../components/HeaderDistributor";

function NoData() {
  return (
    <div className="NoData">
      <img style={{ height: "50%", width: "100%" }} src={error404} />
    </div>
  );
}

export const Kredit = (props) => {
  const dataUser = JSON.parse(localStorage.getItem("dataUser"));
  const { screenName } = useSelector((state) => state.ScreenReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [creditHistory, setCreditHistory] = useState([]);
  const [credit, setCredit] = useState([]);
  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [maxPage, setMaxPage] = useState(1);
  const [loadingApi, setLoadingApi] = useState(true);
  const [
    onEndReachedCalledDuringMomentum,
    setOnEndReachedCalledDuringMomentum,
  ] = useState(false);
  const [alertServerSibuk, setAlertServerSibuk] = useState(false);
  const [alertInet, setAlertInet] = useState(false);

  function alertInternet() {
    return (
      <Stack
        sx={{ position: "fixed", bottom: "11vh" }}
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
      >
        <Alert
          onClose={() => {
            setLoadingApi(false);
            setAlertInet(false);
          }}
          variant="filled"
          severity="info"
        >
          Jaringan internet anda bermasalah
        </Alert>
      </Stack>
    );
  }

  function alertBusy() {
    return (
      <Stack
        sx={{ position: "fixed", bottom: "11vh" }}
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
      >
        <Alert
          onClose={() => {
            setLoadingApi(false);
            setAlertServerSibuk(false);
          }}
          variant="filled"
          severity="info"
        >
          Server sedang sibuk
        </Alert>
      </Stack>
    );
  }

  useEffect(() => {
    getCredit();

    return () => {};
  }, []);

  useEffect(() => {
    if (page) {
      getPage();
    } else if (credit) {
      getPage();
    }

    return () => {};
  }, [page, loadingMore, credit]);

  async function getCredit() {
    await axios({
      method: "get",
      url: `${CONFIG.BASE_URL}/api/credits`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((response) => {
        console.log("response nh=====", response.data);
        const data = response.data.data;
        setCredit(data);
      })
      .catch((error) => {
        let error429 =
          JSON.parse(JSON.stringify(error)).message ===
          "Request failed with status code 429";
        let errorNetwork =
          JSON.parse(JSON.stringify(error)).message === "Network Error";
        let error400 =
          JSON.parse(JSON.stringify(error)).message ===
          "Request failed with status code 400";
        console.log(
          "Cek Error========================",
          JSON.parse(JSON.stringify(error)).message
        );
        if (error429) {
          setAlertServerSibuk(true);
        } else if (errorNetwork) {
          setAlertInet(true);
        } else if (error400) {
          localStorage.removeItem("token");
          navigate("/home");
        }
      });
  }

  async function getPage() {
    await axios({
      method: "get",
      url: `${CONFIG.BASE_URL}/api/credits/history/${credit?.id}`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((response) => {
        const data = response.data.data;
        console.log("data==========", data.data);
        setCreditHistory(
          page == 1 ? data.data : [...creditHistory, ...data.data]
        );
        setRefreshing(false);
        setLoadingMore(data.last_page > page);
        setMaxPage(data.last_page);
        setLoadingApi(false);
      })
      .catch((error) => {
        setLoadingApi(false);
        let error429 =
          JSON.parse(JSON.stringify(error)).message ===
          "Request failed with status code 429";
        let errorNetwork =
          JSON.parse(JSON.stringify(error)).message === "Network Error";
        let error400 =
          JSON.parse(JSON.stringify(error)).message ===
          "Request failed with status code 400";
        console.log(
          "Cek Error========================",
          JSON.parse(JSON.stringify(error)).message
        );
        if (error429) {
          setAlertServerSibuk(true);
        } else if (errorNetwork) {
          setAlertInet(true);
        } else if (error400) {
          localStorage.removeItem("token");
          navigate("/home");
        }
      });
  }

  //load more data
  async function getMoreData() {
    if (!onEndReachedCalledDuringMomentum && page < maxPage) {
      setPage(page + 1);
      setLoadingMore(page < maxPage);
      console.log("ini ketiga", page, loadingMore);
    }
    setOnEndReachedCalledDuringMomentum(page >= maxPage);
  }

  function handleRefresh() {
    setPage(1);
    setRefreshing(true);
  }

  function handleLoadMore() {
    console.log("cekkkkk saiki", !loadingMore);
    if (!loadingMore) return null;
    return (
      <div>
        <CircularProgress color="success" />
      </div>
    );
  }

  return (
    <div className="pointContainer">
      <div className="pointHeader">
        <Header 
        titleHeader="Kerdit"
        />
        {/* <div className="headerComponent">
          <div onClick={() => navigate(-1)} className="headerArrowContainer">
            <img
              src={IconBack}
              alt="headerIconArrow"
              className="headerIconArrow"
            />
          </div>
          <div className="headerTitleContainer">
            <p className="headerTitle">Kredit</p>
          </div>
        </div> */}
        <div className="pointHeaderCard">
          <div className="pointHeaderMain">Kredit</div>
          <div className="pointHeaderMain">7141.5</div>
        </div>
        <div className="pointHeaderFooter">Transaksi Terakhir</div>
      </div>
      <div className="pointListMain">
        {creditHistory.length > 0 && !loadingApi ? (
          <InfiniteScroll
            dataLength={creditHistory.length}
            next={() => getMoreData()}
            hasMore={true}
            loader={() => handleLoadMore()}
            // refreshFunction={handleRefresh}
            // pullDownToRefresh
            // pullDownToRefreshThreshold={50}
            // pullDownToRefreshContent={handleLoadMore}
          >
            {creditHistory.map((item, index) => {
              return (
                <div key={index} className="pointListCard">
                  <div className="pointListHeader">
                    <img
                      src={IconBag}
                      alt="pointListIcon"
                      className="pointListIcon"
                    />
                    Transaksi #{item.order.invoice}
                    <div className="pointListRight">
                      {moment(item.created_at).format("DD MMM YYYY HH:mm")}
                    </div>
                  </div>
                  <div className="pointListContent">
                    <div className="middle">
                      <div className="pointListContentHeader">
                        {item.status}
                      </div>
                      <div className="point">+ {item.deposit}</div>
                    </div>
                    <div className="pointListContentMain">
                      kredit dari semutgajah berhasil
                    </div>
                  </div>
                </div>
              );
            })}
          </InfiniteScroll>
        ) : creditHistory.length == 0 && !loadingApi ? (
          <NoData />
        ) : null}
      </div>
      <Loading loadingApi={loadingApi} />
      {alertServerSibuk ? alertBusy() : null}
      {alertInet ? alertInternet() : null}
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Kredit);
